// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "#33ace1";
var _3 = "#3361e1";
var _4 = "#00a474";
var _5 = "#332a4b";
var _6 = "#95c653";
var _7 = "#f66733";
var _8 = "#f57a7a";
var _9 = "#6d6db5";
var _a = "rgba(109,109,181,.16)";
var _b = "#e02d4f";
var _c = "#fecf0c";
var _d = "#ff892e";
var _e = "rgba(255,137,46,.16)";
var _f = "#a4a7b7";
var _10 = "#cf0838";
var _11 = "rgba(207,8,56,.1)";
var _12 = "rgba(207,8,56,.16)";
var _13 = "rgba(207,8,56,.2)";
var _14 = "rgba(207,8,56,.5)";
var _15 = "rgba(207,8,56,.75)";
var _16 = "rgba(207,8,56,.85)";
var _17 = "#1570ef";
var _18 = "#757575";
var _19 = "#eaecf0";
var _1a = "#d0d5dd";
var _1b = "#98a2b3";
var _1c = "#f9fafb";
var _1d = "#667085";
var _1e = "#344054";
var _1f = "#101828";
var _20 = "#f6f6f6";
var _21 = "#7f56d9";
var _22 = "#8a8fa3";
var _23 = "#f5f4f5";
var _24 = "#e3e7f4";
var _25 = "#959aad";
var _26 = "rgba(149,154,173,.16)";
var _27 = "rgba(149,154,173,.5)";
var _28 = "#e0e0e0";
var _29 = "#95a3ad";
var _2a = "#383838";
var _2b = "#f66733";
var _2c = "rgba(246,103,51,.16)";
var _2d = "rgba(246,103,51,.32)";
var _2e = "rgba(246,103,51,.5)";
var _2f = "rgba(246,103,51,.75)";
var _30 = "#333f48";
var _31 = "rgba(51,63,72,.16)";
var _32 = "rgba(51,63,72,.4)";
var _33 = "rgba(51,63,72,.5)";
var _34 = "rgba(51,63,72,.6)";
var _35 = "#fecf0c";
var _36 = "#333f48";
var _37 = "#3361e1";
var _38 = "rgba(51,97,225,.16)";
var _39 = "#e02d4f";
var _3a = "#4085de";
var _3b = "rgba(64,133,222,.16)";
var _3c = "#1997a3";
var _3d = "#333f48";
var _3e = "#23ccc3";
var _3f = "#fcc7b3";
var _40 = "#222732";
var _41 = "rgba(34,39,50,.25)";
var _42 = "rgba(34,39,50,.5)";
var _43 = "rgba(34,39,50,.75)";
var _44 = "#333f48";
var _45 = "#fff";
var _46 = "#00a474";
var _47 = "rgba(0,164,116,.08)";
var _48 = "rgba(0,164,116,.16)";
var _49 = "rgba(0,164,116,.75)";
var _4a = "#95c653";
var _4b = "#23ccc3";
var _4c = "#ffc107";
var _4d = "rgba(255,193,7,.5)";
var _4e = "#fff";
var _4f = "#e1e1e9";
var _50 = "#fecf0c";
var _51 = "rgba(254,207,12,.16)";
var _52 = "rgba(254,207,12,.25)";
var _53 = "rgba(254,207,12,.75)";
export { _1 as "black", _2 as "boxBlue", _3 as "boxDarkBlue", _4 as "boxDarkGreen", _5 as "boxDarkPurple", _6 as "boxGreen", _7 as "boxOrange", _8 as "boxPink", _9 as "boxPurple", _a as "boxPurple16", _b as "boxRed", _c as "boxYellow", _d as "carrot", _e as "carrot16", _f as "darkGray", _10 as "error", _11 as "error10", _12 as "error16", _13 as "error20", _14 as "error50", _15 as "error75", _16 as "error85", _17 as "graphBlue", _18 as "gray", _19 as "gray200", _1a as "gray300", _1b as "gray400", _1c as "gray50", _1d as "gray500", _1e as "gray700", _1f as "gray900", _20 as "lightGray", _21 as "lightOrchid", _22 as "lightSlateGray", _23 as "lightSmoke", _24 as "lighterGray", _25 as "manatee", _26 as "manatee16", _27 as "manatee50", _28 as "mediumGray", _29 as "navigationText", _2a as "obsidian", _2b as "orange", _2c as "orange16", _2d as "orange32", _2e as "orange50", _2f as "orange75", _30 as "primary", _31 as "primary16", _32 as "primary40", _33 as "primary50", _34 as "primary60", _35 as "primaryButtonBackground", _36 as "primaryButtonText", _37 as "rainboots", _38 as "rainboots16", _39 as "red", _3a as "royalBlue", _3b as "royalBlue16", _3c as "scheduleInterrupt", _3d as "scheduleLoop", _3e as "scheduleMessageBlock", _3f as "scheduleMusic", _40 as "secondary", _41 as "secondary25", _42 as "secondary50", _43 as "secondary75", _44 as "secondaryButtonBackground", _45 as "secondaryButtonText", _46 as "success", _47 as "success10", _48 as "success16", _49 as "success75", _4a as "sushi", _4b as "teal", _4c as "warning", _4d as "warning50", _4e as "white", _4f as "whiteSmoke", _50 as "yellow", _51 as "yellow16", _52 as "yellow25", _53 as "yellow75" }
